/**
* Team List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'team-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.team-list__member-button' ).on( 'toggleAfter', function() {
        const content = $( this ).attr( 'data-toggle-content' );
        const image = $( this ).attr( 'data-toggle-image' );

        $( content ).stop().slideToggle( 500, 'swing' );

        if ( $( image ).hasClass( 'is-open' ) ) {
          $( image ).addClass( 'load-after' );

          // hide the image
          setTimeout( function() {
            $( image ).hide();
          }, 500 );

          // show the image
          setTimeout( function() {
            $( image ).removeClass( 'load-after' );
            $( image ).addClass( 'load-before' );
            $( image ).show();
          }, 600 );
        } else {
          $( image ).removeClass( 'load-before' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-list', COMPONENT );
} )( app );
